import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import SelectedFilterQuestion from "types/Heatmap/SelectedFilterQuestion";
import SelectedFilterQuestionCategory from "types/Heatmap/SelectedFilterQuestionCategory";
import { getProjectHeatmapSettings } from "slices/projectHeatmapSettings/projectHeatmapSettingsSlice";

export interface SelectedFilterQuestionState {
  selectedFilterQuestion: SelectedFilterQuestion | null;
  selectedFilterQuestionCategory: SelectedFilterQuestionCategory | null;
}

const initialState = {
  selectedFilterQuestion: null,
  selectedFilterQuestionCategory: null,
} as SelectedFilterQuestionState;

const selectedFilterQuestionSlice = createSlice({
  name: "selectedFilterQuestion",
  initialState: initialState,
  reducers: {
    resetSelectedFilterQuestion: () => initialState,
    setSelectedFilterQuestion: (state, action: PayloadAction<SelectedFilterQuestion>) => {
      state.selectedFilterQuestion = action.payload;
      state.selectedFilterQuestionCategory = null;
    },
    setSelectedFilterQuestionCategory: (state, action: PayloadAction<SelectedFilterQuestionCategory>) => {
      state.selectedFilterQuestionCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectHeatmapSettings.fulfilled, (state, action) => {
      const selectedFilterQuestion = action.payload.projectSettings.selectedFilterQuestion;
      return selectedFilterQuestion ?? initialState;
    });
  },
});

export const { setSelectedFilterQuestion, setSelectedFilterQuestionCategory, resetSelectedFilterQuestion } =
  selectedFilterQuestionSlice.actions;

export default selectedFilterQuestionSlice.reducer;
